import { jwtDecode } from 'jwt-decode'

/** Separate session keys so Detailing never shares Clinico login storage. */
export const DETAILING_STORAGE = {
  userData: 'detailingUserData',
  accessToken: 'detailingAccessToken',
  refreshToken: 'detailingRefreshToken',
  currentFacility: 'detailingCurrentFacility'
}

export const isDetailingLoggedIn = () => {
  return !!localStorage.getItem(DETAILING_STORAGE.userData) && !!localStorage.getItem(DETAILING_STORAGE.accessToken)
}

export const getDetailingAccessToken = () => localStorage.getItem(DETAILING_STORAGE.accessToken)

export const getDetailingUser = () => {
  try {
    const raw = localStorage.getItem(DETAILING_STORAGE.userData)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const getDetailingFacility = () => {
  try {
    const raw = localStorage.getItem(DETAILING_STORAGE.currentFacility)
    if (!raw || raw === 'null') return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

/**
 * Persist detailing session from /api/v1/auth/login response payload.
 * @param {{ accessToken: string, refreshToken: string, name?: string, email?: string, picture?: string, fullName?: string }} data
 */
export const detailingLogin = data => {
  const userData = {
    name: data.name,
    fullName: data.fullName || data.name,
    email: data.email,
    picture: data.picture
  }

  localStorage.setItem(DETAILING_STORAGE.userData, JSON.stringify(userData))
  localStorage.setItem(DETAILING_STORAGE.accessToken, data.accessToken)
  localStorage.setItem(DETAILING_STORAGE.refreshToken, data.refreshToken)

  try {
    const decoded = jwtDecode(data.accessToken)
    if (decoded?.facilities?.length > 0) {
      localStorage.setItem(DETAILING_STORAGE.currentFacility, JSON.stringify(decoded.facilities[0]))
    } else {
      localStorage.setItem(DETAILING_STORAGE.currentFacility, 'null')
    }
  } catch {
    localStorage.setItem(DETAILING_STORAGE.currentFacility, 'null')
  }
}

export const detailingLogout = () => {
  localStorage.removeItem(DETAILING_STORAGE.userData)
  localStorage.removeItem(DETAILING_STORAGE.accessToken)
  localStorage.removeItem(DETAILING_STORAGE.refreshToken)
  localStorage.removeItem(DETAILING_STORAGE.currentFacility)
}

export const isDetailingPath = pathname => {
  if (!pathname) return false
  return pathname === '/detailing' || pathname.startsWith('/detailing/')
}
